import { useEffect, useState } from "react";
import { readConfigFile } from "utils/appConfig";

const useAfrDocumentsFlow = () => {
  const [isAfrDocumentsFlow, setIsAfrDocumentsFlow] = useState(false);

  useEffect(() => {
    const loadConfiguration = async () => {
      try {
        const config = await readConfigFile();
        setIsAfrDocumentsFlow(config.VITE_YMS_REGION === "AFR");
      } catch (error) {
        console.error("Error loading runtime configuration for the documents flow:", error);
      }
    };

    loadConfiguration();
  }, []);

  return isAfrDocumentsFlow;
};

export default useAfrDocumentsFlow;
